export const limitedColors = ["orange", "#FA3372", "#2555EF"];

export const displayStatus = {
  note: "Updated",
  event: "Added",
  task: "Completed",
};

export const statusBgColor = {
  note: "#fba12c1a",
  event: "#2555ef4f",
  task: "#81dc913d",
};

export const statusTextColor = {
  note: "#fba12c",
  event: "#2555EF",
  task: "#81DC91",
};
